import styled from 'styled-components';

import { Headline } from 'components/Headline';

import { pickColor } from 'themes/helpers/pickColor';
import { pickMotive, TextAreaMotives } from './textAreaMotives';

export type StyledAreaProps = {
  withNoLabel?: boolean;
  motive?: TextAreaMotives;
};

const Container = styled.div<StyledAreaProps>`
  position: relative;

  display: flex;

  ${({ motive }) => motive && pickMotive(motive)};
`;

const Label = styled.label`
  color: ${pickColor('black')};
`;

const Area = styled.textarea<StyledAreaProps>`
  display: block;

  resize: none;
`;

const Error = styled(Headline)`
  position: absolute;

  bottom: 5.5rem;
  left: 0;
`;

const FlagWrapper = styled.div<StyledAreaProps>`
  position: relative;

  flex-grow: 1;

  margin-left: ${({ withNoLabel }) => (withNoLabel ? '12rem' : '0')};

  textarea {
    padding-left: 5.6rem;
    margin-left: 0;
  }
`;

export { Container, FlagWrapper, Label, Area, Error };
